import { infiniteQueryOptions, keepPreviousData } from "@tanstack/react-query";
import { searchFiles } from "@/lib/data/requests/files/search-files";
import { retrieveFileSearchMatterTitles } from "@/lib/data/requests/files/search-file-matter-titles";
import type { FileSearchScope } from "@/lib/data/schemas/files";
import { queryKeys } from "@/lib/data/static/query-keys";

export const fileSearchMatterTitlesOptions = (matterIds: string[]) => ({
  queryKey: [queryKeys.matters, "file-search-titles", matterIds],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    retrieveFileSearchMatterTitles(matterIds, signal),
  enabled: matterIds.length > 0,
  staleTime: 60_000,
  placeholderData: keepPreviousData,
  retry: false,
});

export const fileSearchQueryOptions = (
  filters: FileSearchScope & { q: string },
  enabled: boolean,
) =>
  infiniteQueryOptions({
    queryKey: [queryKeys.files, "search", filters],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam, signal }) => searchFiles(filters, pageParam, signal),
    getNextPageParam: (page) => page.nextCursor ?? undefined,
    enabled: enabled && filters.q.length >= 2 && filters.q.length <= 200,
    staleTime: 0,
    retry: false,
  });
